<template>
  <div class="cg-head">
    <div class="logo"></div>

    <div class="selcountry">
      <!-- 收藏 -->
      <Webapp />

      <!-- 多语言 -->
      <TransLang></TransLang>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Webapp from './webapp.vue'
import TransLang from './transLang.vue'
export default {
  data() {
    return {
      showUserInfo: false,
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      acceptAll: (state) => state.app.acceptAll,
      isNewWebsite: (state) => state.app.isNewWebsite,
    }),
  },
  components: {
    Webapp,
    TransLang,
  },
  created() {
    this.initLang()
    this.$ta.setSuperProperties({
      lang: this.$i18n.locale,
    })

    this.$root.Bus.$on('headHideOther', (str) => {
      str !== 'showUserInfo' && (this.showUserInfo = false)
    })
  },
  mounted() {
    // 监听全局点击事件
    document.addEventListener('click', this.closeUserInfo)
  },
  beforeUnmount() {
    // 组件销毁时移除监听
    document.removeEventListener('click', this.closeUserInfo)
  },
  methods: {
    showUserInfoHandle() {
      if (!this.showUserInfo) {
        this.$root.Bus.$emit('headHideOther', 'showUserInfo')
      }
      this.showUserInfo = !this.showUserInfo
    },
    closeUserInfo() {
      this.showUserInfo = false
    },
    login() {
      this.$root.Bus.$emit('sendmsg', {
        event: 'login',
      })
    },
    logout() {
      this.closeUserInfo()
      this.$root.Bus.$emit('sendmsg', {
        event: 'logout',
      })
    },
    initLang() {
      this.$i18n.locale = this.$utils.getLang()

      // 初始化后保证缓存肯定有语言
      if (!this.acceptAll) {
        this.$utils.customSessionStorage.setItem('vipMallLangCode', this.$i18n.locale)
      } else {
        this.$utils.customLocalStorage.setItem('vipMallLangCode', this.$i18n.locale)
      }

      //用于安装pwa时，不同语言应用名称跟随多语言。
      let appleTouchIcon = document.querySelector('meta[name="apple-mobile-web-app-title"]')
      const title =
        process.env.VUE_APP_GAME_NAME === 'home_ru' ? 'Echofun Games' : this.$t('store.title')
      appleTouchIcon.content = title
      document.title = title
    },
  },
}
</script>

<style lang="less" scoped>
.cg-head {
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  background: rgba(17, 17, 17, 1);
  top: 0;
  left: 0;
  height: 44px;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  .logo {
    height: 22px;
    width: 128.5px;
    background-image: url('@img/logo.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    margin: 0 4px;
  }
  .head-icon {
    width: 30px;
    height: 30px;
    margin-left: 8px;
  }
  .selcountry {
    display: flex;
    align-items: center;

    .head-user {
      margin: 0 4px;
      position: relative;
    }

    .header_login {
      padding: 0 12px;
      height: 26px;
      border-radius: 13px;
      background: rgba(27, 194, 99, 1);
      color: #ffffff;
      font-size: 14px;
      font-weight: 500;
      line-height: 26px;
    }

    .user_icon {
      position: relative;
      cursor: pointer;
      width: 30px;
      height: 30px;
      .bg-image('icon_user');
    }

    .loginfo {
      width: 190px;
      position: absolute;
      right: 0;
      top: 41px;
      background: #ffffff;
      box-shadow: 0px 10px 25px 4px rgba(0, 0, 0, 0.18);
      border-radius: 8px;
      padding: 12px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(52, 58, 63, 1);

      .account {
        width: 100%;
        display: block;
        font-size: 14px;
        color: #202226;
        text-align: center;
        border-bottom: 1px solid rgba(213, 213, 213, 0.6);
        padding-bottom: 8px;
      }

      .out {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
        height: 26px;
        cursor: pointer;

        img {
          width: auto;
          margin-right: 6px;
          height: 20px;
        }
      }
    }
  }
}
</style>
